/**
 * FeedUpcomingEvents.js — EcoScienceInnova
 * Sidebar widget: upcoming events list with date chip.
 *
 * Props:
 *  - events:     [{ id, day, month, title, meta }]
 *  - onViewAll:  () => void
 *  - title:      string
 */
import React from 'react';
import FeedSidebarCard from './FeedSidebarCard';
import './feed.shared.css';

const FeedUpcomingEvents = ({
    events = [],
    onViewAll,
    title = 'Próximos eventos',
}) => {
    return (
        <FeedSidebarCard title={title}>
            <div className="feed-widget-scroll">
                {events.map(ev => (
                    <div key={ev.id} className="feed-event-item">
                        <div className="feed-event-date">
                            <span className="feed-event-day">{ev.day}</span>
                            <span className="feed-event-month">{ev.month}</span>
                        </div>
                        <div className="feed-event-info">
                            <p className="feed-event-title">{ev.title}</p>
                            <p className="feed-event-meta">{ev.meta}</p>
                        </div>
                    </div>
                ))}
            </div>
            {onViewAll && (
                <button className="feed-text-btn" onClick={onViewAll}>
                    Ver calendario completo →
                </button>
            )}
        </FeedSidebarCard>
    );
};

export default FeedUpcomingEvents;
